export default "__VITE_ASSET__DfvQpS0X__"